var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label font-weight-bold label-lg label-inline",class:_vm.bindingClassLabel(),staticStyle:{"width":"max-content"}},[_vm._v(_vm._s(_vm.statusName || _vm.STOCK_CHECK_SHEET_STATUS_NAME[_vm.status]))])
}
var staticRenderFns = []

export { render, staticRenderFns }